import { render } from "./TheNotFound.vue?vue&type=template&id=e0619590&scoped=true"
const script = {}

import "./TheNotFound.vue?vue&type=style&index=0&id=e0619590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0619590"]])

export default __exports__